import { useEffect, useState } from "react"
import { Layer, Source } from "react-map-gl/mapbox"
import type { ICommune } from "@/types/explore"

const DEST_MAP: Record<string, number | undefined> = {
  Toutes: undefined,
  Logement: 1,
  Commerce: 2,
  Bureau: 3,
}

interface PCSLayerProps {
  commune?: ICommune
  filters?: Record<string, unknown>
}

export const PCSLayer = ({ commune, filters }: PCSLayerProps) => {
  const statuses: string[] = (filters?.["pc-status"] as string[]) ?? []
  const year: number | undefined = (filters?.["pc-year"] as number) ?? undefined
  const destLabel: string | undefined = (filters?.["pc-dest"] as string) ?? undefined
  const destination = destLabel ? DEST_MAP[destLabel] : undefined
  const denomination: string | undefined = (filters?.["pc-denomination"] as string) ?? undefined
  const lots: number | undefined = (filters?.["pc-lots"] as number) ?? undefined

  const [geoJsonData, setGeoJsonData] = useState<GeoJSON.FeatureCollection<GeoJSON.Point>>({
    type: "FeatureCollection",
    features: [],
  })

  useEffect(() => {
    if (!commune?.code) return

    const fetchPermits = async () => {
      try {
        const params = new URLSearchParams()
        params.set("commune", commune.code!)
        if (destination != null) params.set("destination", String(destination))
        if (statuses.length > 0) params.set("statuses", statuses.join(","))
        if (year) params.set("year", String(year))
        if (denomination) params.set("denomination", denomination)
        if (lots != null) params.set("lots", String(lots))

        const res = await fetch(`/api/explore/permits?${params.toString()}`)
        if (!res.ok) return

        const pcs = await res.json()
        const features = (pcs || [])
          .filter((pc: Record<string, unknown>) => pc.location)
          .map((pc: Record<string, unknown>) => ({
            type: "Feature" as const,
            geometry: pc.location,
            properties: { ...pc },
          }))

        setGeoJsonData({
          type: "FeatureCollection",
          features,
        } as GeoJSON.FeatureCollection<GeoJSON.Point>)
      } catch (err) {
        console.error("Error fetching permits:", err)
      }
    }

    fetchPermits()
  }, [commune?.code, destination, statuses.join(","), year, denomination, lots])

  return (
    <Source promoteId="id" id="pcs" type="geojson" data={geoJsonData}>
      <Layer
        id="pcs"
        type="circle"
        paint={{
          "circle-radius": 8,
          "circle-color": "white",
          "circle-stroke-color": [
            "case",
            ["==", ["get", "ETAT_DAU"], 2],
            "green",
            ["==", ["get", "ETAT_DAU"], 4],
            "red",
            ["==", ["get", "ETAT_DAU"], 5],
            "yellow",
            ["==", ["get", "ETAT_DAU"], 6],
            "blue",
            "black",
          ],
          "circle-stroke-width": 2,
        }}
      />
    </Source>
  )
}
